import { FC, HTMLInputTypeAttribute, InputHTMLAttributes } from 'react';
import { Field } from 'formik';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  disabled?: boolean;
  value?: string;
  touched?: any;
  type?: HTMLInputTypeAttribute;
  name?: string;
  placeholder?: string;
  error?: string;
  label?: string;
  required?: boolean;
  headText?: string;
}

const Input: FC<InputProps> = ({
  className,
  disabled,
  value,
  touched,
  type,
  name,
  placeholder,
  error,
  label,
  headText,
  ...rest
}) => {
  const test = 'lets';

  return (
    <div>
      {label && (
        <label className="text-white text-lg mb-2" htmlFor={name}>
          {label}
        </label>
      )}
      {headText && (
        <p className="text-white opacity-75 text-xs my-4">{headText}</p>
      )}
      <Field
        value={value}
        name={name}
        id={name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        className={`${className} ${
          touched && touched[name as string] && error
            ? 'border-red-500'
            : touched && touched[name as string] && ''
        } w-full`}
        {...rest}
      />
      {error && touched && <p className="text-red-700 text-xs my-4">{error}</p>}
    </div>
  );
};

export default Input;
